import {FC, useEffect} from 'react';
import {useFormikContext} from 'formik';

import usePrevious from '@/hooks/use-previous';

type Props = {
  onDirtyChange: (isDirty: boolean) => void;
};

export const WatchDirtyChange: FC<Props> = ({onDirtyChange}) => {
  const {dirty} = useFormikContext();
  const previouslyDirty = usePrevious(dirty);

  useEffect(() => {
    if (dirty !== previouslyDirty) {
      onDirtyChange(dirty);
    }
  }, [dirty, previouslyDirty, onDirtyChange]);

  return null;
};
